//系统设置下的公用方法
export default {
  data() {
    return {
      companyArr: [], //获取公司信息
      countryArr: [], //获取全部启用状态的国家
      currencyArr: [], //启用货币
      organizationalStructureArr: [], //启用组织架构,
      areaRelationArr: [], //获取国家、地区树形关系
      userInfoArr: [], //用户设置相关信息
      customerInfo: [], //客户列表
      customerLoading: false,
      brandInfo: [],
      buyerArr: [], //销售员
      userArr:[],//所有可用用户
      salesCode:[],
      warehouse_section_type: [],
      seriesList: [],
      proxy_types:[],//代理性质
      selfLiftingFreightArr: [],
      purchaseDict: {
        // 采购字典
        supplier_type: [], //供应商类型
        contract_type: [], //合同类型
        tax_invoice: [], //发票税率
        clearing_form: [], //结算方式
        preferential_type: [], //优惠类型
        return_type: [], //退货类型
        return_way: [], //退货方式
        shipping_method: [], //供应商送货方式
        refund_method: [], //退款方式
        refund_type: [], //退款类型
        paymentTypeArr:[],//付款类型
        spuPackagingRequirementArr:[],//商品包装要求
        feedback_type: [], //寄样类型
        sample_request_type: [] //样品申请类型
      },
      financeDict: {
        // 财务字典
        account_type: [], //账户类型
        journal_business_type: [], //日记账类型
        discount_type: [], //折扣单类型
        collection_type: [], //收款类型
        subject_type: [], //科目分类
      },
      saleDict: {
        // 销售字典
        order_type: [], //1-订单类型
        charge_type: [], //2-手续费类型
        discount_type: [], //3-折扣类型
        customer_confirm: [], //4-客户确认
        balance_adjustment: [],
        refund_type: [], //6-退款类型
        collection_type: [], //7-收款类型
        complaint_type: [] //8-投诉类型
      },
      warehouseDict:{
        //仓库字典
        warehouse_type:[], //1-仓库类型
        area_type:[], //2-仓库位置区域
        stock_in_type:[], //3-入库单类型
        stock_out_type:[], //4-出库单类型
        section_type:[], //5-库区类型
        trans_fee_type:[], //6-物流运费类型
      },
      platformDict: {
        platform: [],
        shop: [],
        complaint_type: [],
        shipping_method_platform: [],
        shipping_method: []
      },
      productDict: {
        spu_source: [],
        filing_brand_type: [],
        filing_product_type: [],
        filing_smoking_set_type: [],
      },
      now_exchange_rate:'',
      enum_map: {
        Y: "是",
        N: "否"
      },
      status_map: {
        "1": "启用",
        "2": "禁用"
      },
      approve_status_array: {
        "1": "待审核",
        "2": "审核中",
        "3": "已驳回",
        "4": "已通过"
      },
      approveStatusArr: [
        { value: "1", label: "待审核" },
        { value: "2", label: "审核中" },
        { value: "3", label: "已驳回" },
        { value: "4", label: "已通过" },
        { value: "5", label: "已作废" },
      ],
      request_type_arr:{
          '采购付款':'采购付款',
          '运费付款':'运费付款',
          '报关费用付款':'报关费用付款',
          '报关费用报销':'报关费用报销'
      },
      sale_arr: [],
      options: [],
      //日期关联选择，开始-结束
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },

      //日期选择：今天之前
      pickerOptionsBeforeToday: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      pickerOptionsAfterToday: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
    };
  },
  methods: {
    getCompany(callback) {
      //获取公司信息
      _api.get("/base/company/index", { page: 1, pageSize: 10000, status: 1 }).then(res => {
        if (res.code !== 0) {
          this.$message.error(res.message);
        } else {
          this.companyArr = res.data.list;
        }
        if(typeof callback === 'function'){
          callback(res);
        }
      });
    },
    getCurrentExchangeRate(code){
      if(code=='CNY'){
          this.now_exchange_rate = 1;
          return false;
      }
      _api.get('/base/exchange-rate/get-current-exchange-rate',{code:code}).then(res=>{
        if(res.code==0){
            this.now_exchange_rate = res.data;
        }else{
           this.$message.error(res.message);
        }
      })
  },
    countryList() {
      //获取全部启用状态的国家
      _api.get("base/country/get-enable-country").then(res => {
        this.countryArr = res.data ? res.data : [];
      });
    },
    currencyList(callback) {
      //启用货币
      return _api
        .get("/base/currency/index", { page: 1, pageSize: 10000, status: 1 }).then(res => {
          if (res.code !== 0) {
            this.$message.error(res.message);
          } else {
            this.currencyArr = res.data.list ? res.data.list : [];
          }
          if(typeof callback === 'function'){
            callback(res);
          }
        });
    },
    getClassList() {
      //获取分类列表
      _api.get("/product/product-category/get-category-relation").then(res => {
        if (res.code === 0) {
          this.options = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    organizationalStructureList() {
      //启用组织架构
      return _api
        .get("/base/organizational-structure/index", {
          page: 1,
          pageSize: 10000,
          status: 1
        }).then(res => {
          if(res.code !==0){
            this.$message.error(res.message);
            return
          }
          this.organizationalStructureArr = res.data.list ? res.data.list : [];
        });
    },
    getAreaRelation() {
      //获取国家、地区树形关系
      return _api.get("/base/area/get-area-relation").then(res => {
        if (res.code == 0) {
          this.areaRelationArr = res.data;
        }else {
          this.$message.error(res.message);
        }
      });
    },
    //获取品牌列表
    getBrandInfo() {
      _api.get("/warehouse/sku-declare-info/get-brand-info").then(res => {
        if (res.code === 0) {
          this.brandInfo = res.data;
        }else {
          this.$message.error(res.message);
        }
      });
    },
    //获取系列型号列表
    getSeriesList() {
      _api.get("/product/series/get-enable-series-name").then(res => {
        if (res.code === 0) {
          this.seriesList = res.data;
        }else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取所有的用户
    getAllUserInfo() {
      return _api.get("/base/user/all-user-info").then(res => {
        if (res.code == 0) {
          this.userInfoArr = res.data;
        }else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取客户列表
    getCustomerList(query) {
      this.customerLoading = true;
      let param = {
        cust_fullname: query,
        pageSize: 20,
        page: 1
      };
      return _api.get("/sale/customer-info/index", param).then(res => {
        if (res.code == 0) {
          this.customerInfo = res.data.list;
        } else {
          this.$message.error(res.message);
        }
        this.customerLoading = false;
      });
    },
    // 获取客户信息详情
    getCustomerDetail(params, callback) {
      _api.get("/sale/customer-info/detail", params)
        .then(res => {
          if (res.code !== 0) {
            this.$message.error(res.message);
            return false;
          }
          callback(res.data);
        });
    },
    // 自提货代
    getSelfLiftingFreightList() {
      //启用组织架构
      return _api
        .get("/base/self-lifting-freight/index", {
          page: 1,
          pageSize: 10000,
          status: 1
        }).then(res => {
          if(res.code !==0){
            this.$message.error(res.message);
            return
          }
          this.selfLiftingFreightArr = res.data.list ? res.data.list : [];
        });
    },
    // 采购字典
    getDictionary() {
      _api
        .get("/base/purchase-dictionary/get-enable-purchase-dictionary").then(res => {
          let list = res.data;
          list.forEach(item => {
            if (item.type == 1) {
              this.purchaseDict.supplier_type.push(item);
            }
            if (item.type == 2) {
              this.purchaseDict.contract_type.push(item);
            }
            if (item.type == 3) {
              this.purchaseDict.tax_invoice.push(item);
            }
            if (item.type == 5) {
              this.purchaseDict.preferential_type.push(item);
            }
            if (item.type == 6) {
              this.purchaseDict.return_type.push(item);
            }
            if (item.type == 7) {
              this.purchaseDict.return_way.push(item);
            }
            if (item.type == 8) {
              this.purchaseDict.shipping_method.push(item);
            }
            if (item.type == 9) {
              this.purchaseDict.refund_method.push(item);
            }
            if (item.type == 10) {
              this.purchaseDict.refund_type.push(item);
            }
            if (item.type == 11) {
              this.purchaseDict.paymentTypeArr.push(item);
            }
            if (item.type == 12) {
              this.purchaseDict.spuPackagingRequirementArr.push(item);
            }
            if (item.type == 13) {
              this.purchaseDict.feedback_type.push(item);
            }
            if (item.type == 14) {
              this.purchaseDict.sample_request_type.push(item);
            }
          });
        });
    },
    // 财务字典
    getFinanceDictionary() {
      //财务字典
      _api
        .get("/base/finance-dictionary/get-enable-finance-dictionary").then(res => {
          if (res.code === 0) {
            let list = res.data;
            list.forEach(item => {
              if (item.type == 1) {
                this.financeDict.account_type.push(item);
              }
              if (item.type == 2) {
                this.financeDict.journal_business_type.push(item);
              }
              if (item.type == 3) {
                this.financeDict.discount_type.push(item);
              }
              if (item.type == 5) {
                this.financeDict.subject_type.push(item);
              }
            });
          } else {
            this.$message.error(res.message);
          }
        });
    },
    // 第三方平台字典
    getPlatformDictionary() {
      _api.get("/base/platform-dictionary/get-method").then(res => {
        if(res.code !== 0){
          this.$message.error(res.message);
          return
        }
        let list = res.data;
        list.forEach(item => {
          if (item.type == '1') {
            this.platformDict.platform.push(item);
          }
          if (item.type == '2') {
            this.platformDict.shop.push(item);
          }
          if (item.type == '3') {
            this.platformDict.complaint_type.push(item);
          }
          if (item.type == '4') {
            this.platformDict.shipping_method_platform.push(item);
          }
          if (item.type == '5') {
            this.platformDict.shipping_method.push(item);
          }
        });
      });
    },
    // 产品字典
    getProductDictionary() {
      _api.get("/base/product-dictionary/get-method").then(res => {
        if(res.code !== 0){
          this.$message.error(res.message);
          return
        }
        let list = res.data;
        list.forEach(item => {
          if (item.type == '1') {
            this.productDict.spu_source.push(item);
          }
          if (item.type == '2') {
            this.productDict.filing_brand_type.push(item);
          }
          if (item.type == '3') {
            this.productDict.filing_product_type.push(item);
          }
          if (item.type == '4') {
            this.productDict.filing_smoking_set_type.push(item);
          }
        });
      });
    },
    // 销售字典
    getSaleDictionary() {
      _api.get("/base/sale-dictionary/get-sale-dictionary-method").then(res => {
        if(res.code !==0){
          this.$message.error(res.message);
          return
        }
        let list = res.data;
        list.forEach(item => {
          if (item.type == '1') {
            this.saleDict.order_type.push(item);
          }
          if (item.type == '2') {
            this.saleDict.charge_type.push(item);
          }
          if (item.type == '3') {
            this.saleDict.discount_type.push(item);
          }
          if (item.type == '4') {
            this.saleDict.customer_confirm.push(item);
          }
          if (item.type == '5') {
            this.saleDict.balance_adjustment.push(item);
          }
          if (item.type == '6') {
            this.saleDict.refund_type.push(item);
          }
          if (item.type == '7') {
            this.saleDict.collection_type.push(item);
          }
          if (item.type == '8') {
            this.saleDict.complaint_type.push(item);
          }
        });
      });
    },

    // 仓库字典
    getWarehouseDictionary() {
      _api.get("/base/warehouse-dictionary/get-enable-warehouse-dictionary").then(res => {
        if(res.code !==0){
          this.$message.error(res.message);
          return
        }
        let list = res.data;
        list.forEach(item => {
          if (item.type == '1') {
            this.warehouseDict.warehouse_type.push(item);
          }
          if (item.type == '2') {
            this.warehouseDict.area_type.push(item);
          }
          if (item.type == '3') {
            this.warehouseDict.stock_in_type.push(item);
          }
          if (item.type == '4') {
            this.warehouseDict.stock_out_type.push(item);
          }
          if (item.type == '5') {
            this.warehouseDict.section_type.push(item);
          }
          if (item.type == '6') {
            this.warehouseDict.trans_fee_type.push(item);
          }
        });
      });
    },

    // 采购员
    getBuyerList() {
      _api.get("/base/user/get-enable-buyer").then(res => {
        if (res.code === 0) {
          this.buyerArr = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 销售代表
    getSellerList() {
      _api.get("/base/user/get-enable-seller").then(res => {
        if (res.code === 0) {
          this.sale_arr = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },


    //可用的用户数据
    getUserList() {
      _api.get("/base/user/get-enable-user").then(res => {
        if (res.code === 0) {
          this.userArr = res.data;
          this.salesCode = _.filter(res.data, (item) => {
            return (item.sales_code != null && item.sales_code != '');
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },

    //代理性质数据
    getProxyType() {
      return _api
        .get("/base/base-proxy-type/index", {
          page: 1,
          pageSize: 10000,
          status: 1
        }).then(res => {
          if(res.code !==0){
            this.$message.error(res.message);
            return
          }
          this.proxy_types = res.data.list ? res.data.list : [];
        });
    },
    //下载文件
    download(url, index) {
      //动态添加iframe，设置src，然后删除
      setTimeout(function() {
        if (/.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(url)) {
          // 创建隐藏的可下载链接 -- 不可跨域
          var eleLink = document.createElement('a'),
            e = document.createEvent("MouseEvents");
          e.initEvent("click", true, true);
          eleLink.download = url.substring(url.lastIndexOf("/") + 1, url.length);//文件名;
          eleLink.style.display = 'none';
          eleLink.href = url;
          document.body.appendChild(eleLink);
          // eleLink.click();
          eleLink.dispatchEvent(e);

          setTimeout(() => {
            eleLink.remove();
          }, 5000);
        } else {
          let iframe = document.createElement("iframe");
          iframe.style.display = "none";
          iframe.style.height = 0;
          iframe.src = url;
          document.body.appendChild(iframe);
          setTimeout(() => {
            iframe.remove();
          }, 5000);
        }
      }, index * 1000);
    },
//构建下载链接
    downloadUrl(url){
      return window.location.origin + '/base/static-download/index?url=' + url;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/base/index.js